import React, { useState, useEffect } from 'react';
import StaticModal from 'shared/common/modal/staticModal';
import { Link, useHistory } from 'react-router-dom';
import { userStore } from 'store/UserStore';

// import './Redeem.css';
interface PropsType {
  redirectFunc?: any;
  showModal?: any;
  closeModal?: any;
  proceed?: any;
  cancel?: any;
  text?: any;
  keytext?: any;
  okButton?: any;
  cancelButton?: any;
  title?: any;
}

const KycFraudModal: React.FC<PropsType> = ({
  redirectFunc,
  showModal,
  closeModal,
  proceed,
  cancel,
  text,
  keytext,
  okButton,
  cancelButton,
  title,
}) => {
  return (
    <div>
      <StaticModal
        show={showModal}
        handleClose={() => closeModal()}
        title={title}
        onClose={() => {
          closeModal();
        }}
        // size='lg'

        center
      >
        <div>
          <div className='RedeemMainDiv p-3 '>
            <p className='text-1 text-center'>
              <p>
                {text
                  ? text
                  : 'To proceed, please complete your KYC by adding your PAN, Aadhaar, and Bank details in the profile section'}
                <br />
                Click
                <Link
                  to='/profile?bank=true'
                  style={{
                    color: '#99834d',
                    textDecoration: 'underline',
                  }}
                >
                  {' '}
                  Go to profile
                </Link>{' '}
                to complete your KYC.
              </p>
            </p>
          </div>
        </div>
      </StaticModal>
    </div>
  );
};

export default KycFraudModal;
